export const FETCH_METERTYPELIST_BEGIN = 'FETCH_METERTYPELIST_BEGIN';
export const FETCH_METERTYPELIST_SUCCESS = 'FETCH_METERTYPELIST_SUCCESS';
export const FETCH_METERTYPELIST_ERROR = 'FETCH_METERTYPELIST_ERROR';